<template>
    <div class="forgot-pass-pop-up row">
        <template v-if="showDesktop">
            <div class="heading-wrap">
                <h3 class="title">{{ 'Password Reminder' | translate }}</h3>
            </div>
            <div class="content-wrap">
                <form autocomplete="off" @submit.prevent="submit">
                    <div class="form-con form-standard">
                        <div class="form-group">
                            <label>{{ 'Enter you email' | translate }}</label>
                            <div class="input-wrapper">
                                <input class="form-control" type="text" v-model="email.val" :placeholder="'Your email address' | translate">
                            </div>
                        </div>
                        <div class="form-group" v-if="email.error_msg">
                            <div class="error-msg-con">
                                <i class="fa fa-exclamation-triangle"></i> {{ email.error_msg }}
                            </div>
                        </div>
                        <div class="form-group">
                            <button class="btn btn-primary btn-confirm" :disabled="btn_submit_disabled">
                                <span>{{ 'Confirm' | translate | normalize }}</span>
                                <i class="fa fa-spinner fa-pulse" v-if="btn_submit_disabled"></i>
                            </button>
                        </div>
                        <div class="new-account-con">
                            <p>{{ `Don&apos;t have an account?` | translate }} <span @click="goToHome">{{ 'REGISTER' | translate }}</span></p>
                        </div>
                        <div class="form-group" v-if="success_msg">
                            <div class="success-msg-con">
                                {{ success_msg | translate }}
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </template>
        <div v-if="!showDesktop" class="form-con mobile">
            <i class="icon icon-close" @click="goToHome"></i>
            <div class="wrapper">
                <h3 class="title">{{ 'Password Reminder' | translate }}</h3>
                <form autocomplete="off" @submit.prevent="submit">
                    <div class="form-group">
                        <div class="input-wrapper">
                            <input class="form-control" type="text" :placeholder="'Your email address' | translate" v-model="email.val">
                            <div v-if="email.error_msg" class="error-msg-con">
                                <i class="fa fa-exclamation-triangle"></i> {{ email.error_msg }}
                            </div>
                        </div>
                    </div>
                    <div class="btn-group">
                        <button class="btn btn-primary btn-confirm" :disabled="btn_submit_disabled">
                            <span>{{ 'Confirm' | translate | normalize }}</span>
                            <i class="fa fa-spinner fa-pulse" v-if="btn_submit_disabled"></i>
                        </button>
                        <div v-if="success_msg" class="success-msg-con">
                            {{ success_msg | translate }}
                        </div>
                        <button @click.prevent="goToHome" class="btn btn-dark">
                            <span>{{ 'REGISTER' | translate }}</span>
                        </button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
    import {handleErrorReq} from '@/helpers'
    import ForgotPassword from '@views/public/pages/Login/ForgotPassPopUp/forgot_password'

    export default {
        name: 'forgot-pass-pop-up',
        mixins: [ForgotPassword]
    }
</script>

<style lang="scss" scoped src="./forgot_password.scss"></style>
